import { personInfoFrag } from '../../../../utils/type/person.common-type';

export const attendanceCandidateFragment = `
    prescriptionId
    date
    timeFrom
    timeTo
    note
    personId
    person {
        ${personInfoFrag}
    }
`;
